let worker: any = null
let workerLang: string | null = null

export function useOcrWorker() {
  async function getWorkerForLang(lang: string) {
    if (worker && workerLang === lang) return worker

    if (worker) {
      try { await worker.terminate() } catch {}
      worker = null
      workerLang = null
    }

    const mod: any = await import('tesseract.js')
    const createWorker = mod.createWorker ?? mod.default?.createWorker
    if (!createWorker) throw new Error('TESSERACT_CREATE_WORKER_NOT_FOUND')

    const options = {
      workerPath: 'https://cdn.jsdelivr.net/npm/tesseract.js@5/dist/worker.min.js',
      corePath: 'https://cdn.jsdelivr.net/npm/tesseract.js-core@5/tesseract-core.wasm.js',
      langPath: 'https://tessdata.projectnaptha.com/4.0.0'
    }

    // v5 / v4 兼容
    try {
      worker = await createWorker(lang, 1, options)
    } catch {
      worker = await createWorker(options)
      if (typeof worker.loadLanguage === 'function') await worker.loadLanguage(lang)
      if (typeof worker.initialize === 'function') await worker.initialize(lang)
    }

    if (typeof worker.setParameters === 'function') {
      await worker.setParameters({
        preserve_interword_spaces: '1',
        tessjs_create_tsv: '1',
        tessedit_create_tsv: '1'
      })
    }

    workerLang = lang
    return worker
  }

  async function terminate() {
    if (!worker) return
    try { await worker.terminate() } catch {}
    worker = null
    workerLang = null
  }

  return { getWorkerForLang, terminate }
}
